export default __webpack_public_path__ + "static/media/val8.e657e7c8.png";